import React, { useContext, useEffect, useState } from "react";
import { Row, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./InputBar.css";
import {
  getShiftDetils,
  host,
  isIsoDate,
  plantInfo,
} from "../../../../../utils";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "react-bootstrap";
import {
  saveSelectedPlant,
  saveSelectedMachineType,
  saveSelectedLine,
  saveSelectedMachine,
  saveSelectedShift,
  saveSelectedShiftDate,
  saveTimings,
} from "../../../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { ConfigContext } from "../../../../../App";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PlantSelect(props) {
  const [options, setOptions] = useState([]);

  const dispatch = useDispatch();

  let currentPlant = useSelector((state) => state.saveSelectedPlant);
  if (currentPlant[props.InsIden]) {
    currentPlant = currentPlant[props.InsIden].selectedOption;
  } else {
    currentPlant = { value: "" };
  }

  function updationAPI() {
    return axios.get(plantInfo({ i4Usage: true }));
  }

  useEffect(async () => {
    let res = await updationAPI();
    let array = res.data;
    let options = [];
    for (let i = 0; i < array.length; i++) {
      options.push({
        value: array[i]["plantCode"],
        label: array[i]["plantName"],
      });
    }
    if (Array.isArray(props.defaultOptions)) {
      options.push(...props.defaultOptions);
    }
    setOptions(options);
  }, []);

  function onChangeHandler(selectedOption) {
    props.setSelectedPlant(selectedOption);
    dispatch(saveSelectedPlant({ selectedOption, InsIden: props.InsIden }));
  }

  return (
    <>
      <div className={"col-sm-6 col-md-4 col-lg-3"}>
        Select Plant{" "}
        <Select
          className={"from-control option-overflow"}
          defaultValue={currentPlant}
          options={options}
          onChange={onChangeHandler}
        />
      </div>
    </>
  );
}

export function MachineTypeSelect(props) {
  let selectRef = null;
  const dispatch = useDispatch();

  let currentPlant = useSelector((state) => state.saveSelectedPlant);
  if (currentPlant[props.InsIden]) {
    currentPlant = currentPlant[props.InsIden].selectedOption;
  } else {
    currentPlant = { value: "" };
  }

  let currentMachineType = useSelector(
    (state) => state.saveSelectedMachineType
  );
  if (currentMachineType[props.InsIden]) {
    currentMachineType = currentMachineType[props.InsIden].selectedOption;
  } else {
    currentMachineType = { value: "" };
  }

  const [options, setOptions] = useState([]);

  function updationAPI() {
    return axios.get(
      `${host}/machine/info?companyId=&plantId=${currentPlant.value}`
    );
  }

  useEffect(async () => {
    if (selectRef) {
      selectRef.clearValue();
    }
    let res = await updationAPI();
    let array = res.data;
    let options = [];
    let machineTypes = [];
    for (let i = 0; i < array.length; i++) {
      machineTypes.push(array[i]["machineType"]);
    }
    machineTypes = new Set(machineTypes);

    for (let machineType of machineTypes) {
      options.push({
        value: machineType,
        label: machineType,
      });
    }
    if (Array.isArray(props.defaultOptions)) {
      options.push(...props.defaultOptions);
    }
    setOptions(options);
  }, [currentPlant.value]);

  function onChangeHandler(selectedOption) {
    if (selectedOption) {
      props.setSelectedMachineType(selectedOption.value);
      dispatch(
        saveSelectedMachineType({ selectedOption, InsIden: props.InsIden })
      );
    }
  }

  useEffect(() => {
    if (selectRef) {
      selectRef.setValue(currentMachineType);
    }
  }, []);

  return (
    <>
      <div className={"col-sm-6 col-md-4 col-lg-3"}>
        Select Machine Type{" "}
        <Select
          ref={(ref) => {
            selectRef = ref;
          }}
          defaultValue={currentMachineType}
          options={options}
          onChange={onChangeHandler}
          className={"option-overflow"}
        />
      </div>
    </>
  );
}

export function LineSelect(props) {
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  let selectRef = null;

  let currentPlant = useSelector((state) => state.saveSelectedPlant);
  if (currentPlant[props.InsIden]) {
    currentPlant = currentPlant[props.InsIden].selectedOption;
  } else {
    currentPlant = { value: "" };
  }

  let currentMachineType = useSelector(
    (state) => state.saveSelectedMachineType
  );
  if (currentMachineType[props.InsIden]) {
    currentMachineType = currentMachineType[props.InsIden].selectedOption;
  } else {
    currentMachineType = { value: "" };
  }

  let currentLine = useSelector((state) => state.saveSelectedLine);
  if (currentLine[props.InsIden]) {
    currentLine = currentLine[props.InsIden].selectedOption;
  } else {
    currentLine = { value: "" };
  }

  function updationAPI() {
    return axios.get(
      `${host}/machine/info?companyId=&plantId=${currentPlant.value}&machineType=${currentMachineType.value}`
    );
  }

  useEffect(async () => {
    if (selectRef) {
      selectRef.clearValue();
    }
    let res = await updationAPI();
    let array = res.data;
    let options = [];

    let lineIds = [];
    for (let i = 0; i < array.length; i++) {
      lineIds.push(array[i]["lineId"]);
    }
    lineIds = new Set(lineIds);

    for (let lineId of lineIds) {
      options.push({
        value: lineId,
        label: lineId,
      });
    }
    if (Array.isArray(props.defaultOptions)) {
      options.push(...props.defaultOptions);
    }
    setOptions(options);
  }, [currentPlant.value, currentMachineType.value]);

  function onChangeHandler(selectedOption) {
    if (selectedOption) {
      props.setSelectedLineId(selectedOption.value);
      dispatch(saveSelectedLine({ selectedOption, InsIden: props.InsIden }));
    }
  }

  useEffect(() => {
    if (selectRef) {
      selectRef.setValue(currentLine);
    }
  }, []);

  return (
    <>
      <div className={"col-sm-6 col-md-4 col-lg-3"}>
        Select Line{" "}
        <Select
          ref={(ref) => {
            selectRef = ref;
          }}
          defaultValue={currentLine}
          options={options}
          onChange={onChangeHandler}
          className={"option-overflow"}
        />
      </div>
    </>
  );
}

function MachineSelect(props) {
  const [options, setOptions] = useState([]);

  const dispatch = useDispatch();
  let selectRef = null;

  let currentPlant = useSelector((state) => state.saveSelectedPlant);
  if (currentPlant[props.InsIden]) {
    currentPlant = currentPlant[props.InsIden].selectedOption;
  } else {
    currentPlant = { value: "" };
  }

  let currentLine = useSelector((state) => state.saveSelectedLine);
  if (currentLine[props.InsIden]) {
    currentLine = currentLine[props.InsIden].selectedOption;
  } else {
    currentLine = { value: "" };
  }

  let currentMachine = useSelector((state) => state.saveSelectedMachine);
  if (currentMachine[props.InsIden]) {
    currentMachine = currentMachine[props.InsIden].selectedOption;
  } else {
    currentMachine = { value: "" };
  }

  function updationAPI() {
    return axios.get(
      `${host}/machine/info?companyId=&plantId=${currentPlant.value}&lineId=${currentLine.value}`
    );
  }

  useEffect(async () => {
    if (selectRef) {
      selectRef.clearValue();
    }
    let res = await updationAPI();
    let array = res.data;

    let options = [];
    for (let i = 0; i < array.length; i++) {
      options.push({
        value: array[i]["machineId"],
        label: array[i]["machineName"],
      });
    }
    if (Array.isArray(props.defaultOptions)) {
      options.push(...props.defaultOptions);
    }
    setOptions(options);
  }, [currentPlant.value, currentLine.value]);

  function onChangeHandler(selectedOption) {
    if (selectedOption) {
      props.setSelectedMachine(selectedOption.value);
      dispatch(saveSelectedMachine({ selectedOption, InsIden: props.InsIden }));
    }
  }

  useEffect(() => {
    if (selectRef) {
      selectRef.setValue(currentMachine);
    }
  }, []);

  return (
    <>
      <div className={"col-sm-6 col-md-4 col-lg-3"}>
        Select Machine{" "}
        <Select
          ref={(ref) => {
            selectRef = ref;
          }}
          defaultValue={currentMachine}
          options={options}
          onChange={onChangeHandler}
          className={"option-overflow"}
        />
      </div>
    </>
  );
}

function ShiftSelect(props) {
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  let selectRef = null;

  let currentPlant = useSelector((state) => state.saveSelectedPlant);
  if (currentPlant[props.InsIden]) {
    currentPlant = currentPlant[props.InsIden].selectedOption;
  } else {
    currentPlant = { value: "" };
  }

  let currentShift = useSelector((state) => state.saveSelectedShift);
  if (currentShift[props.InsIden]) {
    currentShift = currentShift[props.InsIden].selectedOption;
  } else {
    currentShift = { value: "" };
  }

  function updationAPI() {
    return axios.get(
      `${host}/plantInfo?i4Usage=true&plantCode=${currentPlant.value}`
    );
  }

  useEffect(async () => {
    if (selectRef) {
      selectRef.clearValue();
    }
    try {
      let res = await updationAPI();
      let array = res.data[0]["shifts"];
      let options = [];

      for (let i = 0; i < array.length; i++) {
        options.push({
          value: array[i]["shiftCode"],
          label: array[i]["shiftName"],
        });
      }

      if (Array.isArray(props.defaultOptions)) {
        options.push(...props.defaultOptions);
      }

      setOptions(options);
    } catch (e) {
      console.error(e);
    }
  }, [currentPlant.value]);

  function onChangeHandler(selectedOption) {
    if (selectedOption) {
      props.setShift(selectedOption.value);
      dispatch(saveSelectedShift({ selectedOption, InsIden: props.InsIden }));
    }
  }

  useEffect(() => {
    if (selectRef) {
      selectRef.setValue(currentShift);
    }
  }, []);

  return (
    <>
      <div className={"col-sm-6 col-md-4 col-lg-3"}>
        Select Shift{" "}
        <Select
          ref={(ref) => {
            selectRef = ref;
          }}
          defaultValue={currentShift}
          options={options}
          onChange={onChangeHandler}
          className={"option-overflow"}
        />
      </div>
    </>
  );
}

function ShiftDate(props) {
  const { locale } = useContext(ConfigContext);
  const dispatch = useDispatch();

  let currentDate = useSelector((state) => state.saveSelectedShiftDate);

  if (currentDate[props.InsIden]) {
    currentDate = currentDate[props.InsIden].selectedOption;
  } else {
    currentDate = { value: new Date(), label: "shiftDate" };
  }

  const onShiftDateChange = (value) => {
    props.setShiftDate(value);
    dispatch(
      saveSelectedShiftDate({
        selectedOption: { value, label: "shiftDate" },
        InsIden: props.InsIden,
      })
    );
  };

  return (
    <div className={"col-sm-6 col-md-4 col-lg-3"}>
      Select Date
      <br />
      <DatePicker
        onChange={onShiftDateChange}
        value={currentDate.value}
        selected={currentDate.value}
        className={"form-control"}
        dateFormat="MMMM d, yyyy"
      />
    </div>
  );
}

function StartTime(props) {
  const { locale } = useContext(ConfigContext);
  const dispatch = useDispatch();

  const [currentShiftStartTime, setCurrentShiftStartTime] = useState(
    new Date(new Date().setHours(0, 0, 0))
  );
  if (!props.startTimeMannual) {
    let currentPlant = useSelector((state) => state.saveSelectedPlant);
    if (currentPlant[props.InsIden]) {
      currentPlant = currentPlant[props.InsIden].selectedOption;
    } else {
      currentPlant = { value: "" };
    }

    let currentDate = useSelector((state) => state.saveSelectedShiftDate);
    if (currentDate[props.InsIden]) {
      currentDate = currentDate[props.InsIden].selectedOption;
    } else {
      currentDate = { value: new Date() };
    }

    let currentShift = useSelector((state) => state.saveSelectedShift);
    if (currentShift[props.InsIden]) {
      currentShift = currentShift[props.InsIden].selectedOption;
    } else {
      currentShift = { value: "" };
    }

    const updateData = async () => {
      if (currentDate.value) {
        let shiftDate = currentDate.value
          .getISOStringOfTimezone()
          .split("T")[0];
        let shiftDetails = await getShiftDetils(
          currentPlant.value,
          currentShift.value,
          shiftDate
        );

        if (isIsoDate(shiftDetails.shiftStartTime)) {
          setCurrentShiftStartTime(shiftDetails.shiftStartTime);
        } else {
          setCurrentShiftStartTime(null);
        }
      } else {
        setCurrentShiftStartTime(null);
      }
    };

    useEffect(async () => {
      updateData();
    }, [currentPlant.value, currentShift.value, currentDate.value]);
  } else {
    let timings = useSelector((state) => state.timings);
    timings = timings[props.InsIden];
    useEffect(() => {
      if (timings) {
        setCurrentShiftStartTime(timings.startTime);
      }
    }, []);
  }

  const onStartTimeChange = (value) => {
    dispatch(
      saveTimings({
        type: "START_TIME",
        payload: {
          selectedOption: { value: new Date(value), label: "startTime" },
          InsIden: props.InsIden,
        },
      })
    );
    setCurrentShiftStartTime(value);
  };

  useEffect(async () => {
    dispatch(
      saveTimings({
        type: "START_TIME",
        payload: {
          selectedOption: {
            value: new Date(currentShiftStartTime),
            label: "startTime",
          },
          InsIden: props.InsIden,
        },
      })
    );
  });

  return (
    <div className={"col-sm-6 col-md-4 col-lg-3"}>
      From
      <br />
      <DatePicker
        selected={new Date(currentShiftStartTime)}
        className={"form-control"}
        disabled={props.disabled == undefined ? true : props.disabled}
        showTimeSelect
        dateFormat="MMMM d, yyyy h:mm aa"
        onChange={setCurrentShiftStartTime}
      />
    </div>
  );
}

function EndTime(props) {
  const { locale } = useContext(ConfigContext);
  const dispatch = useDispatch();

  const [currentShiftStartTime, setCurrentShiftStartTime] = useState(
    new Date(new Date().setHours(23, 59, 59.999))
  );

  if (!props.endTimeMannual) {
    let currentPlant = useSelector((state) => state.saveSelectedPlant);
    if (currentPlant[props.InsIden]) {
      currentPlant = currentPlant[props.InsIden].selectedOption;
    } else {
      currentPlant = { value: "" };
    }

    let currentDate = useSelector((state) => state.saveSelectedShiftDate);
    if (currentDate[props.InsIden]) {
      currentDate = currentDate[props.InsIden].selectedOption;
    } else {
      currentDate = { value: new Date() };
    }

    let currentShift = useSelector((state) => state.saveSelectedShift);
    if (currentShift[props.InsIden]) {
      currentShift = currentShift[props.InsIden].selectedOption;
    } else {
      currentShift = { value: "" };
    }

    const updateData = async () => {
      if (currentDate.value) {
        let shiftDate = currentDate.value
          .getISOStringOfTimezone()
          .split("T")[0];
        let shiftDetails = await getShiftDetils(
          currentPlant.value,
          currentShift.value,
          shiftDate
        );
        if (isIsoDate(shiftDetails.shiftEndTime)) {
          setCurrentShiftStartTime(shiftDetails.shiftEndTime);
        } else {
          setCurrentShiftStartTime(null);
        }
      } else {
        setCurrentShiftStartTime(null);
      }
    };

    useEffect(async () => {
      updateData();
    }, [currentPlant.value, currentShift.value, currentDate.value]);
  } else {
    let timings = useSelector((state) => state.timings);
    timings = timings[props.InsIden];
    useEffect(() => {
      if (timings) {
        setCurrentShiftStartTime(timings.endTime);
      }
    }, []);
  }

  const onStartTimeChange = (value) => {
    dispatch(
      saveTimings({
        type: "END_TIME",
        payload: {
          selectedOption: { value: new Date(value), label: "endTime" },
          InsIden: props.InsIden,
        },
      })
    );
    setCurrentShiftStartTime(value);
  };

  useEffect(async () => {
    dispatch(
      saveTimings({
        type: "END_TIME",
        payload: {
          selectedOption: {
            value: new Date(currentShiftStartTime),
            label: "endTime",
          },
          InsIden: props.InsIden,
        },
      })
    );
  });

  return (
    <div className={"col-sm-6 col-md-4 col-lg-3"}>
      To
      <br />
      <DatePicker
        selected={new Date(currentShiftStartTime)}
        className={"form-control"}
        disabled={props.disabled == undefined ? true : props.disabled}
        onChange={onStartTimeChange}
        showTimeSelect
        dateFormat="MMMM d, yyyy h:mm aa"
      />
    </div>
  );
}

const InputBar = (props) => {
  toast.configure();
  const [selectedPlant, setSelectedPlant] = useState("");
  const [selectedMachineType, setSelectedMachineType] = useState("");
  const [selectedLineId, setSelectedLineId] = useState("");
  const [selectedMachine, setSelectedMachine] = useState("");
  const [shift, setShift] = useState("");
  const [shiftDate, setShiftDate] = useState("");
  const navigate = useNavigate();

  const onFetchClick = () => {
    props.setFetchStatus(!props.fetchStatus);
  };

  let machineType = useSelector((state) => state.saveSelectedMachineType);
  if (machineType.downtime) {
    machineType = machineType.downtime.selectedOption.value;
  } else {
    machineType = "";
  }

  let machineVis = true;
  if(machineType == 'welding'){
    machineVis = false;
  }

  return (
    <>
      <Row>
      {(props.plant === "disable")  ? (
        <></>
       ) : (
        <PlantSelect
          setSelectedPlant={setSelectedPlant}
          InsIden={props.InsIden}
          defaultOptions={(() => {
            try {
              return props.defaultOptions.plant;
            } catch (e) {
              return false;
            }
          })()}
        ></PlantSelect>
       )}
        {props.machineType ? (
          <>
            <br />
            <MachineTypeSelect
              setSelectedMachineType={setSelectedMachineType}
              InsIden={props.InsIden}
              defaultOptions={(() => {
                try {
                  return props.defaultOptions.machineType;
                } catch (e) {
                  return false;
                }
              })()}
            />
          </>
        ) : (
          <></>
        )}

        {props.line ? (
          <>
            <br />
            <LineSelect
              setSelectedLineId={setSelectedLineId}
              InsIden={props.InsIden}
              defaultOptions={(() => {
                try {
                  return props.defaultOptions.line;
                } catch (e) {
                  return false;
                }
              })()}
            />
          </>
        ) : (
          <></>
        )}
        {props.machine && machineVis ? (
          <>
            <br />
            <MachineSelect
              setSelectedMachine={setSelectedMachine}
              InsIden={props.InsIden}
              defaultOptions={(() => {
                try {
                  return props.defaultOptions.machine;
                } catch (e) {
                  return false;
                }
              })()}
            ></MachineSelect>
          </>
        ) : (
          <></>
        )}
        {props.shift ? (
          <>
            <br />
            <ShiftSelect
              setShift={setShift}
              InsIden={props.InsIden}
            ></ShiftSelect>
          </>
        ) : (
          <></>
        )}
        {props.shiftDate ? (
          <>
            <br />
            <ShiftDate
              setShiftDate={setShiftDate}
              InsIden={props.InsIden}
            ></ShiftDate>
          </>
        ) : (
          <></>
        )}
        {props.startTime ? (
          <>
            <br />
            <StartTime
              InsIden={props.InsIden}
              disabled={props.startTimeDisabled}
              startTimeMannual={props.startTimeMannual}
            ></StartTime>
          </>
        ) : (
          <></>
        )}
        {props.endTime ? (
          <>
            <br />
            <EndTime
              InsIden={props.InsIden}
              disabled={props.endTimeDisabled}
              endTimeMannual={props.endTimeMannual}
            ></EndTime>
          </>
        ) : (
          <></>
        )}
       {(props.fetchBtn === "disable")  ? (
        <></>
       ) : (
        <div className={"col-sm-6 col-md-4 col-lg-3"}>
          &nbsp;{" "}
          <Button onClick={onFetchClick} className={"w-100"}>
            {props.loading ? (
              <Spinner size="sm" animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              "Fetch"
            )}
          </Button>
        </div>
       )}
        {props.goback.show ? (
          <div className={"col-sm-6 col-md-4 col-lg-3"}>
            &nbsp;{" "}
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="danger"
              className={"w-100"}
            >
              Go Back
            </Button>
          </div>
        ) : (
          <></>
        )}
      </Row>
    </>
  );
};

InputBar.defaultProps = {
  goback: { show: false },
};

InputBar.startTime = {
  disabled: true,
};

InputBar.endTime = {
  disabled: true,
};

export default InputBar;
